import { createContext, useContext, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import useInterfacePermissions from '@/hooks/useInterfacePermissions'
import { matchInterfaceCodeForPath } from '../utils/accessControlUtils'

const InterfacePermissionContext = createContext(null)

export const InterfacePermissionProvider = ({ interfaceCode: forcedCode, children }) => {
  const { pathname } = useLocation()
  const resolvedCode = useMemo(
    () => forcedCode || matchInterfaceCodeForPath(pathname) || '',
    [forcedCode, pathname]
  )
  const perms = useInterfacePermissions(resolvedCode)

  return (
    <InterfacePermissionContext.Provider value={perms}>
      {children}
    </InterfacePermissionContext.Provider>
  )
}

/** Page-level permissions — provider context or current route fallback. */
export const usePagePermissions = () => {
  const ctx = useContext(InterfacePermissionContext)
  const { pathname } = useLocation()
  const routeCode = matchInterfaceCodeForPath(pathname) || ''
  const routePerms = useInterfacePermissions(routeCode)
  if (ctx) return ctx
  return routePerms
}

export default InterfacePermissionContext
